import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Shell from "./components/Shell";
import Login from "./screens/Login";
import Staff from "./screens/staff/ManageStaff";
import Audits from "./screens/Audits/Audit";
import ManageAudit from "./screens/Audits/ManageAudit";
import Bookings from "./screens/Bookings/Booking";
import ManageBooking from "./screens/Bookings/ManageBookings";
import { endSession, getAccount } from "./session";

function App() {
  const [vendor, setVendor] = useState(() => getAccount());

  const logout = () => {
    endSession();
    setVendor(null);
  };

  if (!vendor) {
    return (
      <Router>
        <Routes>
          <Route path="/" element={<Login onSignedIn={setVendor} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Shell vendor={vendor} logout={logout}>
        <Routes>
          <Route path="/audits" element={<Audits />} />
          <Route path="/audits/manage-audit/:audit_id" element={<ManageAudit />} />
          <Route path="/bookings" element={<Bookings />} />
          <Route path="/bookings/manage-booking/:booking_id" element={<ManageBooking />} />
          <Route path="/manage-staff" element={<Staff />} />
          <Route path="*" element={<Navigate to="/audits" replace />} />
        </Routes>
      </Shell>
    </Router>
  );
}

export default App;
